import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs, noEs } from '../data/content';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-paper py-11 sm:py-14 lg:py-16" aria-labelledby="faq" data-id="element-14" data-mp="1blak3b9kuvuy">
      <div className="mx-auto w-full max-w-3xl px-5 sm:px-8" data-id="element-15" data-mp="1gj3n5vfl39r0">
        <h2 id="faq" className="font-display text-2xl font-extrabold leading-[1.12] tracking-tight text-navy sm:text-4xl" data-id="element-16" data-mp="1glgev0b58yh9">
          Antes de comprar, seamos claros
        </h2>

        {/* Qué NO es */}
        <ul className="mt-5 grid grid-cols-1 gap-2 rounded-2xl border border-navy/10 bg-white p-5 sm:grid-cols-3 sm:gap-4" data-id="element-17" data-mp="1ujwksp16mkyc">
          {noEs.map(item => <li key={item} className="flex items-start gap-2 text-[14px] leading-snug text-navy-soft" data-id="element-18" data-mp="1zgd6lckwsn89">
              <MinusIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy-muted" aria-hidden="true" data-id="element-19" data-mp="2n67inrxem7rg" />
              {item}
            </li>)}
        </ul>

        <div className="mt-8 divide-y divide-navy/10 border-y border-navy/10" data-id="element-20" data-mp="14w3jd0zffqlk">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} data-id="element-21" data-mp="1eldc8j23hdaq" data-mpi={i}>
                <h3 data-id="element-22" data-mp="1emoe2dbzcaz7">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-start justify-between gap-4 py-4 text-left transition-colors duration-150 ease-out hover:text-celeste-deeper" data-id="element-23" data-mp="1en6l8506k9lw">
                    <span className="font-display text-[17px] font-bold leading-snug text-navy" data-id="element-24" data-mp="1xhv9th3mk7ew">
                      {faq.q}
                    </span>
                    <PlusIcon className={`mt-0.5 h-5 w-5 shrink-0 text-celeste-deep transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-25" data-mp="36zt1riadm11" />
                  </button>
                </h3>
                <div id={`faq-panel-${i}`} hidden={!isOpen} className="pb-4 pr-8 text-[15px] leading-relaxed text-navy-soft" data-id="element-26" data-mp="23aaevlu2af2r">
                  {faq.a}
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}